import DisplayNews from "../components/pages/displayNews/DisplayNews.js";

export default function NewsLink() {
  return <DisplayNews />;
}
